const SubscriptionForm = () => import('./SubscriptionForm')
const FeedbackForm = () => import('./FeedbackForm')

export default function installComponents(Vue) {
  Vue.component('SubscriptionForm', SubscriptionForm)
  Vue.component('FeedbackForm', FeedbackForm)
}
